import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'
import { FC } from 'react'

type Props = {
  open: boolean
  fileName?: string
  onConfirm: () => void
  onCancel: () => void
}

export const UploadConfirmDialog: FC<Props> = ({
  open,
  fileName,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="glossary-upload-confirm-dialog-title"
    >
      <DialogTitle id="glossary-upload-confirm-dialog-title">
        アップロードを実行しますか？
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          {fileName && (
            <Typography
              variant="body2"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {fileName}
            </Typography>
          )}
          <Typography variant="body2">
            このファイルをアップロードし、最新版として差し替えます。データに誤りがないかを確認した上で実行してください。
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ padding: 2 }}>
        <Button onClick={onCancel} color="secondary" variant="contained">
          キャンセル
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          実行
        </Button>
      </DialogActions>
    </Dialog>
  )
}
